import React, { forwardRef, useEffect, useRef } from 'react';

const Textarea = forwardRef(
  (
    {
      label,
      value,
      onChange,
      placeholder,
      error,
      required = false,
      disabled = false,
      helpText,
      rows = 4,
      autoResize = false,
      className = '',
      id,
      ...props
    },
    ref
  ) => {
    const textareaId = id || (label ? `ta-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    const localRef = useRef(null);
    const setRef = (el) => {
      localRef.current = el;
      if (typeof ref === 'function') ref(el);
      else if (ref) ref.current = el;
    };

    useEffect(() => {
      if (!autoResize || !localRef.current) return;
      const el = localRef.current;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }, [value, autoResize]);

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-app-text mb-1">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </label>
        )}
        <textarea
          ref={setRef}
          id={textareaId}
          value={value ?? ''}
          onChange={onChange}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          rows={rows}
          aria-invalid={!!error}
          className={`
            w-full px-4 py-2 border rounded-lg text-app-text resize-y
            focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
            disabled:bg-app-surface disabled:cursor-not-allowed
            ${error ? 'border-error' : 'border-gray-300'}
            ${className}
          `
            .trim()
            .replace(/\s+/g, ' ')}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-error">{error}</p>}
        {helpText && !error && (
          <p className="mt-1 text-xs text-app-text-secondary">{helpText}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
